import { removeAllChildNodes } from "../../globals/utils"

const _setFallBack = (bannerContainer) => {
    removeAllChildNodes(bannerContainer);

    bannerContainer.innerHTML = `
        <div class="randomImgBanner fallBack" id="fallBackBanner">
            <div class="fallBackImg"><span class="sr-only">Why Join VIN</span></div>
        </div>
    `;
};

const RandomBanner = (appendElem) => {
    $j.get("/apputil/VINControlRenderer.ashx?ControlName=PromoRandomBanner", function(data) {
        appendElem.innerHTML = data;
    })
    .fail(function(err) {
        console.error(err);
        _setFallBack(appendElem);
    });
};

export { RandomBanner };